import classNames from "classnames";
import React from "react";
import { FormattedTime } from "react-intl";
import { DAY_NAMES } from "@fidget/common/utils/getWorkingHours";
import { ActiveHours, ActiveHoursDay } from "../../types";
import tagGroupsStyles from "../tagGroups.css";
import styles from "./activeHoursSummary.css";

interface Props {
  activeHours: ActiveHours;
}
export const ActiveHoursSummary = ({ activeHours }: Props) => {
  return (
    <div className={tagGroupsStyles.form}>
      <div className={tagGroupsStyles.column}>
        <ActiveDaySummary dayName={DAY_NAMES[0]!} day={activeHours.$[0]!} />
        <ActiveDaySummary dayName={DAY_NAMES[1]!} day={activeHours.$[1]!} />
        <ActiveDaySummary dayName={DAY_NAMES[2]!} day={activeHours.$[2]!} />
      </div>
      <div className={tagGroupsStyles.column}>
        <ActiveDaySummary dayName={DAY_NAMES[3]!} day={activeHours.$[3]!} />
        <ActiveDaySummary dayName={DAY_NAMES[4]!} day={activeHours.$[4]!} />
      </div>
      <div className={tagGroupsStyles.column}>
        <ActiveDaySummary dayName={DAY_NAMES[5]!} day={activeHours.$[5]!} />
        <ActiveDaySummary dayName={DAY_NAMES[6]!} day={activeHours.$[6]!} />
      </div>
    </div>
  );
};

interface ActiveDayProps {
  dayName: string;
  day: ActiveHoursDay;
}
const ActiveDaySummary = ({ dayName, day }: ActiveDayProps) => {
  return (
    <div className={styles.row}>
      <p className={classNames(styles.font, styles["day-name"])}>{dayName}</p>
      <div className={classNames(styles.row, styles.hours)}>
        <p className={styles.font}>
          <FormattedTime value={day.from} />
        </p>
        <div className={styles.hyphen}> - </div>
        <p className={styles.font}>
          <FormattedTime value={day.to} />
        </p>
      </div>
    </div>
  );
};
